/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
function ready(callback) {
    // in case the document is already rendered
    if (document.readyState !== 'loading') {
        callback();
    }
    // modern browsers
    else if (document.addEventListener) {
        document.addEventListener('DOMContentLoaded', callback);
    }
    // IE <= 8
    else {
        document.attachEvent('onreadystatechange', function () {
            if (document.readyState === 'complete') {
                callback();
            }
        });
    }
}

(function () {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {

                (function () {
                    [].forEach.call(document.querySelectorAll('[data-lightgallery]'),function(i){
                        lightGallery(i);
                    });
                })();

                (function () {
                    var _toggle = document.querySelectorAll('[data-toggle]');

                    var _showed = [];
                    var isOpen = false;

                    Array.from(_toggle).forEach(function (el) {
                        var type = el.getAttribute('data-toggle-type');

                        if(el.classList.contains("is-active")) {
                            _showed = Array.from(document.querySelectorAll(el.getAttribute('data-toggle')));
                            _showed.push(el);
                            isOpen = el;
                        }

                        el.addEventListener('click', function () {
                            window.dispatchEvent(new CustomEvent('toggle.start', {
                                detail: { isOpen: isOpen },
                            }));

                            if (isOpen !== false) {
                                while (_showed.length > 0) {
                                    _showed.pop().classList.remove('is-active');
                                }
                            }

                            window.dispatchEvent(new CustomEvent('toggle.clean'));

                            if (isOpen !== this && type !== "close") {
                                var _targets = Array.from(document.querySelectorAll(this.getAttribute('data-toggle')));
                                _targets.push(this);

                                _targets.forEach(function (el) {
                                    el.classList.add('is-active');
                                    _showed.push(el);
                                });
                                isOpen = this;

                                window.dispatchEvent(new CustomEvent('toggle.opened', {
                                    detail: { isOpen: isOpen, targets: _targets },
                                }));

                                return;
                            }

                            window.dispatchEvent(new CustomEvent('toggle.closed'));

                            isOpen = false;
                        });
                    });

                    ['click', 'touchstart'].map(function (event) {
                        document.body.addEventListener(event, function (e) {
                            var _current = e.target;

                            while (_current !== document.documentElement && !_showed.some(function(el) { return el === _current; })){ // jshint ignore:line
                                _current = _current.parentElement;
                            }

                            if (_current === document.documentElement) {
                                while (_showed.length > 0) {
                                    _showed.pop().classList.remove('is-active');
                                }
                                isOpen = false;

                                window.dispatchEvent(new CustomEvent('toggle.closed'));
                            }
                        });
                    });
                })();

                (function() {
                    var _form = document.getElementById('form_mobileSearch');

                    window.addEventListener('toggle.opened', function (e) {
                        if (e.detail.targets.includes(_form)) {
                            _form.querySelector('.js-search').focus();
                        }
                    });

                    window.addEventListener('toggle.closed', function () {
                        _form.querySelector('.js-search').blur();
                    });
                })();

                (function () {
                    window.addEventListener('load', function () {
                        var nodes = document.querySelectorAll('.js-sticky');

                        Array.from(nodes).forEach(function (node) {
                            var nodeOffs = node.offsetTop,
                                fake = document.createElement('div');

                            fake.style.width = '100%';
                            fake.style.height = node.offsetHeight + 'px';
                            fake.style.marginBottom = getComputedStyle(node).marginBottom;
                            fake.style.display = 'none';

                            node.parentNode.insertBefore(fake, node);

                            window.addEventListener('scroll', function () {
                                var scrollPos = (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);

                                if ((scrollPos >= nodeOffs)) {
                                    node.classList.add('_stuck');
                                    document.body.classList.add('_stuck');
                                    fake.style.display = getComputedStyle(node).display;
                                } else {
                                    node.classList.remove('_stuck');
                                    document.body.classList.remove('_stuck');
                                    fake.style.display = 'none';
                                }
                                if (node.offsetTop !== 0) {
                                    nodeOffs = node.offsetTop;
                                }
                            });

                            window.addEventListener('resize', function () {
                                if (node.offsetTop !== 0) {
                                    nodeOffs = node.offsetTop;
                                }
                                fake.style.height = node.offsetHeight + 'px';
                            });
                        });

                        window.dispatchEvent(new Event('scroll'));
                    });
                })();

                (function search_live() {
                    var _search = document.getElementsByClassName('js-search');
                    if (_search.length) {
                        [].forEach.call(_search, function (_s) {
                            var _list = _s.parentNode.querySelector('.js-search-list');
                            var tim;
                            var CancelToken = axios.CancelToken;
                            var _loupe = _s.parentNode.querySelector('.js-search-loupe');
                            var cancel = function () {
                            };
                            _s.addEventListener('input', function () {
                                var value = this.value;
                                _list.innerHTML = "";
                                if (value.length >= 1) {
                                    _list.classList.add('_show', '_search');
                                    clearTimeout(tim);
                                    tim = setTimeout(function () {
                                        cancel('restart');
                                        axios({
                                            method: 'post',
                                            url: '/wp-admin/admin-ajax.php?action=data_fetch',
                                            params: {
                                                keyword: value
                                            },
                                            cancelToken: new CancelToken(function executor(c) {
                                                cancel = c;
                                            })
                                        })
                                            .then(function (response) {
                                                _list.innerHTML = response.data;
                                                _list.classList.remove('_search');
                                            }).catch(function (reason) {
                                            if (reason.message !== 'restart') {
                                                _list.classList.remove('_show', '_search');
                                            }
                                        });
                                    }, 300);
                                } else {
                                    _list.classList.remove('_show', '_search');
                                }
                            });

                            _s.parentNode.addEventListener('reset', function (e) {
                                e.preventDefault();

                                if(!_s.value) {
                                    _loupe.dispatchEvent(new Event("click"));
                                } else {
                                    _s.value = "";
                                }
                            });
                        });
                    }

                })();

                (function(){
                    var _sub_menus = document.querySelectorAll('#menu_mobile .-menu._sub .-menu._sub');
                    _sub_menus.forEach(function (menu) {
                        var _parent = menu.parentNode;
                        _parent.classList.add('_arrow');
                        _parent.addEventListener('click',function (e) {
                            if(!(e.target.tagName === 'A' || e.target.tagName === 'SPAN')){
                                e.preventDefault();
                                _parent.classList.toggle('_opened');
                            }
                        });
                    });
                })();

                (function() {
                    Array.from(document.getElementsByClassName('js-search-form')).forEach(function(_form) {
                        _form.addEventListener('submit', function (e) {
                            if (this.querySelector('.js-search').value.length === 0) {
                                e.preventDefault();
                            }
                        });
                    });
                })();
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
                (function () {
                    var _carousel = document.querySelector('#carousel');
                    if (! _carousel) {
                        return;
                    }
                    var siema = new Siema({
                        selector: _carousel.getElementsByClassName('-inner')[0],
                        duration: 750,
                        easing: 'ease-out',
                        perPage: 1,
                        startIndex: 0,
                        draggable: true,
                        multipleDrag: true,
                        threshold: 20,
                        loop: true,
                        rtl: false,
                        onInit: function () {
                            this.interval = setInterval(function () {
                                siema.next();
                            }, 7000);
                        },
                        onChange: function () {
                            clearInterval(siema.interval);
                            this.interval = setInterval(function () {
                                siema.next();
                            }, 7000);
                            var dots = this.selector.parentNode.getElementsByClassName('-dot');
                            [].forEach.call(dots, function (el) {
                                el.classList.remove('_active');
                            });
                            dots[this.currentSlide].classList.add('_active');
                        },
                        interval: null
                    });
                    _carousel.querySelectorAll('.-arrow._left')[0].addEventListener('click', function () {
                        siema.prev();
                    });

                    _carousel.querySelectorAll('.-arrow._right')[0].addEventListener('click', function () {
                        siema.next();
                    });

                    Siema.prototype.addPagination = function () {
                        var f = function (i) {
                            var _this = this;
                            var btn = document.createElement('button');
                            btn.classList.add('-dot');
                            btn.addEventListener('click', function () {
                                _this.goTo(i);
                                [].forEach.call(this.parentNode.childNodes, function (el) {
                                    el.classList.remove('_active');
                                });
                                this.classList.add('_active');
                            });
                            this.selector.parentNode.getElementsByClassName('-dots')[0].appendChild(btn);
                        };
                        for (var i = 0; i < this.innerElements.length; i++) {
                            f.call(this, i);
                        }
                    };
                    siema.addPagination();
                })();
                (function () {
                    var _carousel = document.querySelector('#carousel_small');
                    var _inner = _carousel.getElementsByClassName('-inner')[0];
                    if (_inner.childElementCount > 4) {
                        var siema = new Siema({
                            selector: _inner,
                            duration: 750,
                            easing: 'ease-out',
                            perPage: {
                                360: 1,
                                576: 2,
                                768: 3,
                                992: 4,
                                1200: 5
                            },
                            startIndex: 0,
                            draggable: true,
                            multipleDrag: true,
                            threshold: 20,
                            loop: true,
                            rtl: false,
                            onInit: function () {
                                this.interval = setInterval(function () {
                                    siema.next();
                                }, 7000);
                            },
                            onChange: function () {
                                clearInterval(siema.interval);
                                this.interval = setInterval(function () {
                                    siema.next();
                                }, 7000);
                            },
                            interval: null
                        });
                        _carousel.querySelectorAll('.-arrow._left')[0].addEventListener('click', function () {
                            siema.prev();
                        });

                        _carousel.querySelectorAll('.-arrow._right')[0].addEventListener('click', function () {
                            siema.next();
                        });
                    } else {
                        _carousel.classList.add('d-none');
                    }
                })();
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'category': {
            init: function () {
                (function filter() {
                    var _filter = document.getElementById('filter');
                    if (_filter) {
                        var _filter_item = _filter.getElementsByClassName('-item');
                        var _grid = document.getElementById('filter-grid');
                        var grid = [];
                        [].forEach.call(_grid.getElementsByClassName('-card'), function (el) {
                            grid.push({
                                el: el,
                                grid: JSON.parse(el.getAttribute('data-filter'))
                            });
                        });
                        [].forEach.call(_filter_item, function (el) {
                            el.addEventListener('click', function () {
                                [].forEach.call(_filter_item, function (el) {
                                    el.classList.remove('_active');
                                });
                                this.classList.add('_active');
                                var _this = this;
                                grid.forEach(function (gr) {
                                    if (gr.grid.indexOf(_this.getAttribute('data-filter')) !== -1) {
                                        gr.el.classList.remove('_hidden');
                                    } else {
                                        gr.el.classList.add('_hidden');
                                    }
                                });
                            });
                        });
                    }
                })();
            }
        },
        'page_template_template_contacts': {
            init: function () {
                var myMap,
                    myPlacemark,
                    MyIconContentLayout;

                function init() {
                    myMap = new window.ymaps.Map("map", {
                        center: [59.884479, 30.276157],
                        zoom: 16
                    });

                    MyIconContentLayout = ymaps.templateLayoutFactory.createClass(
                        '<div style="color: #FFFFFF; font-weight: bold;">$[properties.iconContent]</div>');

                    myPlacemark = new window.ymaps.Placemark([59.884779, 30.275657], {
                        hintContent: 'ОПЫТНО - ЭКСПЕРИМЕНТАЛЬНЫЙ МЕХАНИЧЕСКИЙ ЗАВОД'
                    }, {
                        // Опции.
                        // Необходимо указать данный тип макета.
                        iconLayout: 'default#imageWithContent',
                        // Своё изображение иконки метки.
                        iconImageHref: document.getElementById('map').getAttribute('data-placemark'),
                        // Размеры метки.
                        iconImageSize: [29, 35],
                        // Смещение левого верхнего угла иконки относительно
                        // её "ножки" (точки привязки).
                        iconImageOffset: [0, 0],
                        // Смещение слоя с содержимым относительно слоя с картинкой.
                        iconContentOffset: [0, 0],
                        // Макет содержимого.
                        iconContentLayout: MyIconContentLayout
                    });

                    myMap.geoObjects.add(myPlacemark);
                }

                window.ymaps.ready(init);

                (function () {
                    function validate(el) {
                        var type = el.getAttribute('data-val-type');
                        var value = el.value;
                        el.classList.remove('_error');
                        if (parseInt(type)) {
                            if (value.length < type) {
                                el.classList.add('_error');
                                return false;
                            }
                        } else {
                            switch (type) {
                                case 'empty':
                                    if (!value) {
                                        el.classList.add('_error');
                                        return false;
                                    }
                                    break;
                                case 'email':
                                    if (!value || !value.match(/^[-._a-z0-9]+@(?:[a-z0-9][-a-z0-9]+\.)+[a-z]{2,6}$/i)) {
                                        el.classList.add('_error');
                                        return false;
                                    }
                                    break;

                                case 'phone':
                                    if (!value || !value.match(/^((8|\+)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/i)) {
                                        el.classList.add('_error');
                                        return false;
                                    }
                                    break;

                                case 'select':
                                    if (!value || value === 'disabled' ) {
                                        el.classList.add('_error');
                                        return false;
                                    }
                                    break;
                                case 'consent':
                                    if (!el.checked) {
                                        el.classList.add('_error');
                                        return false;
                                    }
                                    break;

                                default:
                                // console.warn('Error Type');
                            }
                        }
                        return true;
                    }

                    function validateAll(form) {
                        var r = true;
                        [].forEach.call(form.querySelectorAll('input,textarea,select'), function (_v) {
                            r = validate(_v) && r;
                        });
                        if (r) {
                            form.querySelector('[type="submit"]').removeAttribute('disabled');
                        } else {
                            form.querySelector('[type="submit"]').setAttribute('disabled', 'disabled');
                        }
                        return r;
                    }

                    function reset(_form) {
                        _form.reset();
                        _form.querySelector('[type="submit"]').setAttribute('disabled', 'disabled');
                    }

                    function serialize(form) {
                        var serialized = {};
                        var elements = Array.from(form.querySelectorAll('input,textarea,select'));

                        elements.forEach(function (field) {
                            // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
                            if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') {
                                return true;
                            }

                            // If a multi-select, get all selections
                            if (field.type === 'select-multiple') {
                                for (var n = 0; n < field.options.length; n++) {
                                    if (!field.options[n].selected) {
                                        continue;
                                    }
                                    serialized[field.name] = field.options[n].value;
                                }
                            }

                            // Convert field data to a query string
                            else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
                                serialized[field.name] = field.value;
                            }
                        });

                        return JSON.stringify(serialized);
                    }

                    var _forms = document.querySelectorAll('form[data-action]');

                    if(_forms.length) {
                        var script_recaptcha = document.createElement('script');
                        script_recaptcha.src = 'https://www.google.com/recaptcha/api.js?onload=recaptcha_onload&render=explicit';
                        document.head.appendChild(script_recaptcha);

                        window.recaptcha_onload = function () {
                            Array.from(document.getElementsByClassName('g-recaptcha')).forEach(function (_r) {
                                window.grecaptcha.render(_r, {
                                    'sitekey': '6Le093QUAAAAAFk1pIzGQ3v0Di3x2pBCMOg_8Ec8',
                                    'callback': function (token) {
                                        _r.setAttribute('data-token', token);
                                        console.log('recaptcha callback');
                                        _r.closest('form').dispatchEvent(new Event('submit', {bubbles: true}));
                                    },
                                    'expired-callback': function () {
                                        console.log('expired-callback', this);
                                    },
                                    'error-callback': function () {
                                        console.log('error-callback', this);
                                    },
                                });
                                _r.setAttribute('disabled', 'disabled');
                            });
                        };
                    }

                    _forms.forEach(function (_form) {
                        _form.setAttribute('novalidate', '');
                        var _consentText = _form.querySelector('[data-consent-toggle]');
                        if (_consentText) {
                            _consentText.addEventListener('click', function (e) {
                                if (e.target.closest('a')) {
                                    return;
                                }
                                var _checkbox = _form.querySelector('#consent_checkbox');
                                if (!_checkbox) {
                                    return;
                                }
                                _checkbox.checked = !_checkbox.checked;
                                _checkbox.dispatchEvent(new Event('change', { bubbles: true }));
                            });
                        }
                        _form.querySelectorAll('input,textarea,select').forEach(function (_el) {
                            _el.addEventListener('input', function () {
                                validate(this);
                                validateAll(_form, false);
                            });
                            _el.addEventListener('change', function () {
                                validate(this);
                                validateAll(_form, false);
                            });
                        });

                        var sending = false;

                        _form.addEventListener('submit', function (e) {
                            e.preventDefault();

                            console.log(serialize(_form));

                            if (sending || !validateAll(_form)) {
                                window.grecaptcha.reset();
                                return;
                            }

                            sending = true;
                            _form.classList.add('loading');

                            fetch(_form.getAttribute('data-action'), {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: serialize(_form),
                            }).then(function (r) {
                                return r.json();
                            }).catch(function (err) {
                                _form.classList.remove('loading');
                                sending = false;
                                console.log(err);
                            }).then(function (json) {
                                console.log(json);
                                _form.classList.remove('loading');
                                sending = false;

                                if (json.success) {
                                    alert('Доставлено');
                                    reset(_form);
                                } else if (json.error) {
                                    _form.querySelectorAll('[name="' + json.error.join('"],[name="') + '"]').forEach(function (el) {
                                        el.classList.add('error');
                                    });
                                }

                                window.grecaptcha.reset();
                            });
                        });
                    });
                })();
            }
        },
        'post_template_template_product': {
            init: function () {
                var _tables = document.getElementsByTagName('table');
                [].forEach.call(_tables,function (el) {
                    var wrapper = document.createElement('div');
                    wrapper.style.overflowX = 'auto';
                    el.parentNode.insertBefore(wrapper, el);

                    wrapper.appendChild(el);
                });
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            document.body.className.replace(/-/g, '_').split(/\s+/).forEach(function (classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    ready(UTIL.loadEvents);

})();